<template>
    <div class="documentos-da-origem">
        <!--
          FASE 4 / AF-2 — DOC 54, 59 e 78.

          Componente ÚNICO montado pelas telas de outros módulos. É o que faz a integração
          existir do lado do usuário: sem ele, os três requisitos seriam apenas endpoints.

          Recebe a entidade de origem (tipo + id) e mostra o que o acervo tem sobre ela,
          incluindo o estado das assinaturas — que é o "integrações com documentos assinados"
          do DOC 54. Daqui também se envia para assinatura sem sair da tela (DOC 78).
        -->
        <el-row class="u-mb-10">
            <el-col :xs="24" :sm="14">
                <strong>{{ titulo }}</strong>
                <small class="u-text-muted" v-if="itens.length"> · {{ itens.length }}</small>
            </el-col>
            <el-col :xs="24" :sm="10" class="u-text-right">
                <el-button v-if="podeVincular" type="primary" size="mini" icon="el-icon-link"
                           @click="abrirVincular">VINCULAR DOCUMENTO</el-button>
            </el-col>
        </el-row>

        <div v-loading="carregando">
            <table class="table table-striped" v-if="itens.length">
                <thead>
                    <tr>
                        <th>Documento</th>
                        <th class="hidden-xs-only" style="width:150px">Vinculado em</th>
                        <th style="width:190px">Assinatura</th>
                        <th style="width:150px"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="d in itens" :key="d.vinculo_id">
                        <td>{{ d.titulo }}</td>
                        <td class="hidden-xs-only">{{ d.criado_em | dataHora }}</td>
                        <td>
                            <!-- DOC 54: o estado da assinatura, dentro do módulo de origem -->
                            <template v-if="d.assinatura">
                                <el-tag size="mini" :type="corSituacao(d.assinatura.situacao)">
                                    {{ rotuloSituacao(d.assinatura.situacao) }}
                                </el-tag>
                                <small class="u-text-muted">
                                    {{ d.assinatura.assinados }}/{{ d.assinatura.total }}
                                </small>
                                <div v-if="d.assinatura.codigo">
                                    <small>
                                        <a href="javascript:;" @click="verificar(d.assinatura.codigo)">
                                            verificar
                                        </a>
                                    </small>
                                </div>
                            </template>
                            <small class="u-text-muted" v-else>sem assinatura</small>
                        </td>
                        <td class="u-text-right">
                            <el-button size="mini" plain icon="el-icon-view"
                                       title="Abrir no módulo Documentos"
                                       @click="abrirDocumento(d.documento_id)"></el-button>

                            <!-- DOC 78: assinar sem sair da tela de origem -->
                            <el-button v-if="podeAssinar(d)" size="mini" type="success" plain
                                       icon="el-icon-s-check" title="Enviar para assinatura"
                                       @click="abrirAssinar(d)"></el-button>

                            <el-button class="u-ml-10" v-if="podeVincular" size="mini" type="danger" plain
                                       icon="el-icon-delete" title="Desvincular"
                                       @click="desvincular(d)"></el-button>
                        </td>
                    </tr>
                </tbody>
            </table>

            <div v-if="!itens.length && !carregando" class="u-text-center u-text-muted u-mt-10">
                Nenhum documento vinculado a este registro.
            </div>
        </div>

        <!-- vincular documento já existente do acervo -->
        <el-dialog title="Vincular documento do acervo" :visible.sync="dialogVincular" width="520px">
            <el-select v-model="documentoEscolhido" filterable remote style="width:100%"
                       :remote-method="buscarDocumentos" :loading="buscando"
                       placeholder="Digite parte do título do documento">
                <el-option v-for="d in encontrados" :key="d.id" :label="d.titulo" :value="d.id"></el-option>
            </el-select>
            <span slot="footer">
                <el-button @click="dialogVincular = false">Cancelar</el-button>
                <el-button class="u-ml-10" type="primary" :disabled="!documentoEscolhido" @click="vincular">VINCULAR</el-button>
            </span>
        </el-dialog>

        <!-- DOC 78: abrir assinatura a partir daqui -->
        <el-dialog title="Enviar para assinatura" :visible.sync="dialogAssinar" width="520px">
            <el-form label-position="top">
                <el-form-item label="Assinantes">
                    <el-select v-model="assinantesEscolhidos" multiple filterable remote style="width:100%"
                               :remote-method="buscarAssinantes" :loading="buscandoAssinante"
                               placeholder="Digite o nome">
                        <el-option v-for="u in assinantes" :key="u.id" :label="u.name" :value="u.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="Prazo (opcional)">
                    <el-date-picker v-model="prazoAssinatura" type="date" style="width:100%"
                                    value-format="yyyy-MM-dd" placeholder="Data limite"></el-date-picker>
                </el-form-item>
            </el-form>
            <span slot="footer">
                <el-button @click="dialogAssinar = false">Cancelar</el-button>
                <el-button class="u-ml-10" type="primary" :disabled="!assinantesEscolhidos.length"
                           @click="enviarParaAssinatura">ENVIAR</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import moment from 'moment'

export default {
    name: 'documentos-da-origem',
    filters: {
        dataHora (v) { return v ? moment(v).format('DD/MM/YYYY HH:mm') : '—' }
    },
    props: {
        /** relatorio | matricula | aluno | servidor | requerimento */
        origemTipo: { type: String, required: true },
        origemId: { type: [String, Number], required: true },
        titulo: { type: String, default: 'Documentos vinculados' }
    },
    data: () => ({
        itens: [],
        carregando: false,
        dialogVincular: false,
        documentoEscolhido: '',
        encontrados: [],
        buscando: false,
        dialogAssinar: false,
        documentoParaAssinar: null,
        assinantes: [],
        assinantesEscolhidos: [],
        prazoAssinatura: '',
        buscandoAssinante: false
    }),
    computed: {
        base () { return this.$store.state.config.baseUrlApi },
        /* Perfis que escrevem no módulo. O backend recusa de qualquer forma; isto só evita
           mostrar botão que vai falhar. */
        podeVincular () {
            return [0, 1, 3, 4, 5, 6, 7, 8, 12].indexOf(Number(this.$store.state.user.tipo)) !== -1
        }
    },
    watch: {
        origemId () { this.carregar() }
    },
    mounted () { this.carregar() },
    methods: {
        auth () { return this.$store.getters.getHeaderAuth },

        carregar () {
            if (!this.origemId) return

            this.carregando = true

            this.$axios.get(
                `${this.base}/api/documento-integracao/da-origem/${this.origemTipo}/${this.origemId}`,
                this.auth()
            ).then(r => {
                this.itens = r.data || []
                this.carregando = false
            }).catch(e => {
                this.carregando = false
                this.itens = []
                // 403 é esperado para quem não acessa o módulo: some sem alarde.
                if (e.response && e.response.status !== 403) {
                    this.$message.error('Não foi possível carregar os documentos vinculados.')
                }
            })
        },

        corSituacao (s) {
            return { concluido: 'success', em_andamento: 'warning',
                     recusado: 'danger', cancelado: 'info' }[s] || 'info'
        },
        rotuloSituacao (s) {
            return { concluido: 'assinado', em_andamento: 'aguardando',
                     recusado: 'recusado', cancelado: 'cancelado' }[s] || s
        },
        podeAssinar (d) {
            if (!this.podeVincular) return false
            return !d.assinatura || ['recusado', 'cancelado'].indexOf(d.assinatura.situacao) !== -1
        },

        abrirDocumento (id) {
            this.$router.push(`/admin/documento/detalhe/${id}`)
        },
        verificar (codigo) {
            window.open(`${this.base}/api/publico/assinatura/verificar/${codigo}`, '_blank')
        },

        // ------------------------------------------------ DOC 54: vincular
        abrirVincular () {
            this.documentoEscolhido = ''
            this.encontrados = []
            this.dialogVincular = true
        },
        buscarDocumentos (termo) {
            if (!termo || termo.length < 2) return

            this.buscando = true

            this.$axios.post(`${this.base}/api/documento/getAllPaginate`,
                { termo, por_pagina: 20 }, this.auth()
            ).then(r => {
                this.encontrados = (r.data && r.data.data) || []
                this.buscando = false
            }).catch(() => { this.buscando = false; this.encontrados = [] })
        },
        vincular () {
            this.$axios.post(`${this.base}/api/documento-integracao/vincular`, {
                documento_id: this.documentoEscolhido,
                origem_tipo: this.origemTipo,
                origem_id: this.origemId
            }, this.auth()).then(() => {
                this.dialogVincular = false
                this.$message.success('Documento vinculado.')
                this.carregar()
            }).catch(e => {
                this.$message.error((e.response && e.response.data && e.response.data.message)
                    || 'Não foi possível vincular.')
            })
        },
        desvincular (d) {
            this.$confirm('Desvincular este documento do registro?', 'Confirmação',
                { type: 'warning' }
            ).then(() => {
                this.$axios.delete(
                    `${this.base}/api/documento-integracao/desvincular/${d.vinculo_id}`, this.auth()
                ).then(() => { this.$message.success('Desvinculado.'); this.carregar() })
                 .catch(e => this.$message.error((e.response && e.response.data
                        && e.response.data.message) || 'Não foi possível desvincular.'))
            }).catch(() => {})
        },

        // ------------------------------------------------ DOC 78: assinar da origem
        abrirAssinar (d) {
            this.documentoParaAssinar = d
            this.assinantesEscolhidos = []
            this.prazoAssinatura = ''
            this.assinantes = []
            this.dialogAssinar = true
        },
        buscarAssinantes (termo) {
            if (!termo || termo.length < 2) return

            this.buscandoAssinante = true

            this.$axios.post(`${this.base}/api/documento-compartilhamento/destinos/documento/${this.documentoParaAssinar.documento_id}`,
                { termo }, this.auth()
            ).then(r => {
                this.assinantes = (r.data && r.data.usuarios) || []
                this.buscandoAssinante = false
            }).catch(() => { this.buscandoAssinante = false; this.assinantes = [] })
        },
        enviarParaAssinatura () {
            const corpo = {
                documento_id: this.documentoParaAssinar.documento_id,
                assinantes: this.assinantesEscolhidos.map(id => ({ user_id: id })),
                natureza: 'Integração'
            }

            if (this.prazoAssinatura) corpo.data_limite = this.prazoAssinatura

            this.$axios.post(
                `${this.base}/api/documento-integracao/assinar/${this.origemTipo}/${this.origemId}`,
                corpo, this.auth()
            ).then(() => {
                this.dialogAssinar = false
                this.$message.success('Documento enviado para assinatura.')
                this.carregar()
            }).catch(e => {
                this.$message.error((e.response && e.response.data && e.response.data.message)
                    || 'Não foi possível enviar para assinatura.')
            })
        }
    }
}
</script>

<style scoped>
.documentos-da-origem { margin-top: 14px; }
.u-mr-5 { margin-right: 5px; }
</style>
